import { useFormik } from "formik";
import * as Yup from 'yup'
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom";
// import { TostMsg } from "../../../App";
import { LoaderContext } from "../../../../../Services/Loader_Provider_Service/LoadingContext";
import { addModule } from "../../Services/SelfLearning";

function AddModule() {
    const { showLoading, hideLoading } = useContext(LoaderContext);
    // const toster = useContext(TostMsg);
    const { CourseId } = useParams();
    let navigateTo = useHistory();
    let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
    const moduleValidation = Yup.object().shape({
        ModuleName: Yup.string().required('Module name is required.'),
        Description: Yup.string().required('Description is required.'),
    })

    const moduleForm = useFormik({
        initialValues: {
            ModuleName: '',
            Description: ''
        },
        validationSchema: moduleValidation,
        onSubmit: async (data) => {
            showLoading();
            let params = {
                "Id": 0,
                "GUID": userDetails.GUID,
                "IsActive": true,
                "CreatedDate": new Date(),
                "ModifiedDate": new Date(),
                "CreatedBy": userDetails.EmpId,
                "ModifiedBy": userDetails.EmpId,
                "OrgId": userDetails.OrgId,
                "AccountId": userDetails?.OrgId,
                "CourseId": CourseId,
                "ModuleName": data.ModuleName,
                "Description": data.Description,
                "lstLessons": [
                    {
                        "Id": 0,
                        "GUID": userDetails.GUID,
                        "IsActive": true,
                        "CreatedDate": new Date(),
                        "ModifiedDate": new Date(),
                        "CreatedBy": userDetails.EmpId,
                        "ModifiedBy": userDetails.EmpId,
                        "OrgId": userDetails.OrgId,
                        "AccountId": userDetails?.OrgId,
                        "CourseId": CourseId,
                        "ModuleId": userDetails.EmpId,
                        "Title": "string",
                        "VideoURL": "string",
                        "Duration": "string",
                        "IsViewed": true
                    }
                ],
                "lstQuiz": [
                    {
                        "Id": 0,
                        "GUID": userDetails.GUID,
                        "IsActive": true,
                        "CreatedDate": new Date(),
                        "ModifiedDate": new Date(),
                        "CreatedBy": userDetails.EmpId,
                        "ModifiedBy": userDetails.EmpId,
                        "OrgId": userDetails.OrgId,
                        "AccountId": userDetails?.OrgId,
                        "CourseId": CourseId,
                        "ModuleId": userDetails.EmpId,
                        "QuizName": "string",
                        "IsQuizCompleted": true
                    }
                ],
                "lstQuizQuestion": [
                    {
                        "Id": 0,
                        "GUID": userDetails.GUID,
                        "IsActive": true,
                        "CreatedDate": new Date(),
                        "ModifiedDate": new Date(),
                        "CreatedBy": userDetails.EmpId,
                        "ModifiedBy": userDetails.EmpId,
                        "OrgId": userDetails.OrgId,
                        "QuestionText": "string",
                        "QuestionType": "string",
                        "AnsTypeId": 0,
                        "QUIZid": 0,
                        "CourseId": CourseId,
                        "ModuleId": userDetails.EmpId,
                        "lstQuestionOptions": [
                            {
                                "Id": 0,
                                "GUID": userDetails.GUID,
                                "IsActive": true,
                                "CreatedDate": new Date(),
                                "ModifiedDate": new Date(),
                                "CreatedBy": userDetails.EmpId,
                                "ModifiedBy": userDetails.EmpId,
                                "OrgId": userDetails.OrgId,
                                "Empid": 0,
                                "QuestionId": 0,
                                "Options": "string",
                                "IsCorrectId": true,
                                "ModuleId": userDetails.EmpId,
                                "QuizId": 0,
                                "CourseId": CourseId,
                                "LessonId": 0,
                                "Answerid": 0
                            }
                        ]
                    }
                ]
            }
            try {
                let response = await addModule(params);
                // navigateTo.push(`/SelfLearningDashboard/CourseDetails/${CourseId}`)
                hideLoading();
            } catch (err) {
                hideLoading();
            }
        }
    })



    return (
        <div>
            <div id="circular-menu" className="circular-menu">
                <a className="floating-btn" >
                    <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
                    <i aria-hidden="true" className="fa fa-times"></i>
                </a>

                <div className="items-wrapper">
                    <div className="menu-item is-flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </div>
                    <a className="menu-item is-flex right-panel-trigger" data-panel="languages-panel">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </a>
                    <Link to="" className="menu-item is-flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </Link>
                    <a className="menu-item is-flex right-panel-trigger" data-panel="activity-panel">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-grid"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
                    </a>
                </div>

            </div>
            {/* <!-- row --> */}
            <div className="container-fluid">
                <div className="col-md-8 shrink-w">
                    <div className="form-head d-flex flex-wrap align-items-center mb-3">
                        <div className="me-auto">
                            <h2 className="font-w600 mb-0">Add Module</h2>
                            <p className="text-light">Lorem ipsum dolor sit amet</p>
                        </div>
                        <div className="rightside-tabs">
                            {/* <Link to={`/SelfLearningDashboard/CourseDetails/${CourseId}`}><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-arrow-left-short" viewBox="0 0
 16 16"><path fillRule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.7
 07l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5
 .5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"></path></svg></Link> */}
                        </div>
                    </div>
                    <div className="row">
                        <form onSubmit={moduleForm.handleSubmit}>
                            <div className="col-xl-12">
                                <div className="col-xl-12">
                                    <div className="supp-req">
                                        <div className="addcourseform">
                                            <div className="row">
                                                <div className="mb-4 col-md-12">
                                                    <input type="text" cols="1" rows="4"
                                                        name="ModuleName"
                                                        value={moduleForm.values.ModuleName}
                                                        onChange={moduleForm.handleChange}
                                                        className={"form-control bg-chng" + (moduleForm.errors.ModuleName && moduleForm.touched.ModuleName ? 'is-invalid' : '')}
                                                        placeholder="Your Lesson title goes here.." />
                                                    <div className="invalid-feedback">{moduleForm.errors.ModuleName && moduleForm.touched.ModuleName ? moduleForm.errors.ModuleName : null}</div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="mb-4 col-md-12">
                                                    <label className="form-label">Description</label>
                                                    <div className="cover-form">
                                                        <textarea className={"form-control h-auto" + (moduleForm.errors.Description && moduleForm.touched.Description ? 'is-invalid' : '')} rows="8" cols="1"
                                                            name="Description"
                                                            onChange={moduleForm.handleChange}
                                                            value={moduleForm.values.Description}
                                                            placeholder="write some lines about this course.."
                                                        ></textarea>
                                                    </div>
                                                    <div className="invalid-feedback">{moduleForm.errors.Description && moduleForm.touched.Description ? moduleForm.errors.Description : null}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="btns-grp">
                                    <button type="submit" className="savebtn-click">Save</button>
                                    <button type="submit" className="publish-click">Publish</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="give-rating">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <img src="images/org-img/learn/rate.png" />
                        <div className="modal-header p-0">
                            <h5 className="modal-title m-auto">How would you rate your course experience?</h5>
                        </div>
                        <div className="modal-body text-center">
                            <ul className="rate">
                                <li><i className="fa fa-star"></i></li>
                                <li><i className="fa fa-star"></i></li>
                                <li><i className="fa fa-star"></i></li>
                                <li><i className="fa fa-star-o"></i></li>
                                <li><i className="fa fa-star-o"></i></li>
                            </ul>
                            <form>
                                <div className="form-group text-left">
                                    <textarea rows="6" cols="1" className="form-control" placeholder="I would like to say that..."></textarea></div>

                            </form>
                        </div>
                        <div className="modal-footer">
                            <i className="fa fa-angle-right" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    )
}
export default AddModule;